<template>
  <v-container>
    <h1>Feedback</h1>
    <p v-for="item in submissions" :key="item.id" class="mb-6">
      <strong>{{ item.category }} </strong>
      {{ new Date(item.time_posted).toLocaleDateString() }}
      {{ new Date(item.time_posted).toLocaleTimeString() }}
      <br />
      {{ item.content }}
      <br />
      <v-btn color="primary" @click="resolve(item.id)">Resolve</v-btn>
    </p>
  </v-container>
</template>

<script>
export default {
  name: "FeedbackReviewPage",
  data: () => ({
    submissions: [],
  }),
  mounted() {
    this.getFeedback();
  },
  methods: {
    getFeedback: function () {
      this.$axios.get("/feedback").then((response) => {
        this.submissions = response.data;
        console.log(response.data);
      });
    },

    resolve: async function (id) {
      await this.$axios.post("/resolve-feedback", {
        id,
      });

      this.submissions = this.submissions.filter((item) => item.id !== id);
    },
  },
};
</script>

<style scoped></style>
